(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9908],{

/***/ 96808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ useSwipeable; }
/* harmony export */ });
/* unused harmony exports DOWN, LEFT, RIGHT, UP */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);


const LEFT = "Left";
const RIGHT = "Right";
const UP = "Up";
const DOWN = "Down";

/* global document */
const defaultProps = {
    delta: 10,
    preventScrollOnSwipe: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true,
    swipeDuration: Infinity,
    touchEventOptions: { passive: true },
};
const initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0],
};
const mouseMove = "mousemove";
const mouseUp = "mouseup";
const touchEnd = "touchend";
const touchMove = "touchmove";
const touchStart = "touchstart";
function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
        if (deltaX > 0) {
            return RIGHT;
        }
        return LEFT;
    }
    else if (deltaY > 0) {
        return DOWN;
    }
    return UP;
}
function rotateXYByAngle(pos, angle) {
    if (angle === 0)
        return pos;
    const angleInRadians = (Math.PI / 180) * angle;
    const x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    const y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
}
function getHandlers(set, handlerProps) {
    const onStart = (event) => {
        const isTouch = "touches" in event;
        // if more than a single touch don't track, for now...
        if (isTouch && event.touches.length > 1)
            return;
        set((state, props) => {
            // setup mouse listeners on document to track swipe since swipe can leave container
            if (props.trackMouse && !isTouch) {
                document.addEventListener(mouseMove, onMove);
                document.addEventListener(mouseUp, onUp);
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            props.onTouchStartOrOnMouseDown &&
                props.onTouchStartOrOnMouseDown({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { initial: xy.slice(), xy, start: event.timeStamp || 0 });
        });
    };
    const onMove = (event) => {
        set((state, props) => {
            const isTouch = "touches" in event;
            // Discount a swipe if additional touches are present after
            // a swipe has started.
            if (isTouch && event.touches.length > 1) {
                return state;
            }
            // if swipe has exceeded duration stop tracking
            if (event.timeStamp - state.start > props.swipeDuration) {
                return state.swiping ? Object.assign(Object.assign({}, state), { swiping: false }) : state;
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const [x, y] = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            const deltaX = x - state.xy[0];
            const deltaY = y - state.xy[1];
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);
            const time = (event.timeStamp || 0) - state.start;
            const velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
            const vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
            const dir = getDirection(absX, absY, deltaX, deltaY);
            // if swipe is under delta and we have not started to track a swipe: skip update
            const delta = typeof props.delta === "number"
                ? props.delta
                : props.delta[dir.toLowerCase()] ||
                    defaultProps.delta;
            if (absX < delta && absY < delta && !state.swiping)
                return state;
            const eventData = {
                absX,
                absY,
                deltaX,
                deltaY,
                dir,
                event,
                first: state.first,
                initial: state.initial,
                velocity,
                vxvy,
            };
            // call onSwipeStart if present and is first swipe event
            eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
            // call onSwiping if present
            props.onSwiping && props.onSwiping(eventData);
            // track if a swipe is cancelable (handler for swiping or swiped(dir) exists)
            // so we can call preventDefault if needed
            let cancelablePageSwipe = false;
            if (props.onSwiping ||
                props.onSwiped ||
                props[`onSwiped${dir}`]) {
                cancelablePageSwipe = true;
            }
            if (cancelablePageSwipe &&
                props.preventScrollOnSwipe &&
                props.trackTouch &&
                event.cancelable) {
                event.preventDefault();
            }
            return Object.assign(Object.assign({}, state), { 
                // first is now always false
                first: false, eventData, swiping: true });
        });
    };
    const onEnd = (event) => {
        set((state, props) => {
            let eventData;
            if (state.swiping && state.eventData) {
                // if swipe is less than duration fire swiped callbacks
                if (event.timeStamp - state.start < props.swipeDuration) {
                    eventData = Object.assign(Object.assign({}, state.eventData), { event });
                    props.onSwiped && props.onSwiped(eventData);
                    const onSwipedDir = props[`onSwiped${eventData.dir}`];
                    onSwipedDir && onSwipedDir(eventData);
                }
            }
            else {
                props.onTap && props.onTap({ event });
            }
            props.onTouchEndOrOnMouseUp && props.onTouchEndOrOnMouseUp({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { eventData });
        });
    };
    const cleanUpMouse = () => {
        // safe to just call removeEventListener
        document.removeEventListener(mouseMove, onMove);
        document.removeEventListener(mouseUp, onUp);
    };
    const onUp = (e) => {
        cleanUpMouse();
        onEnd(e);
    };
    /**
     * The value of passive on touchMove depends on `preventScrollOnSwipe`:
     * - true => { passive: false }
     * - false => { passive: true } // Default
     *
     * NOTE: When preventScrollOnSwipe is true, we attempt to call preventDefault to prevent scroll.
     *
     * props.touchEventOptions can also be set for all touch event listeners,
     * but for `touchmove` specifically when `preventScrollOnSwipe` it will
     * supersede and force passive to false.
     *
     */
    const attachTouch = (el, props) => {
        let cleanup = () => { };
        if (el && el.addEventListener) {
            const baseOptions = Object.assign(Object.assign({}, defaultProps.touchEventOptions), props.touchEventOptions);
            // attach touch event listeners and handlers
            const tls = [
                [touchStart, onStart, baseOptions],
                // preventScrollOnSwipe option supersedes touchEventOptions.passive
                [
                    touchMove,
                    onMove,
                    Object.assign(Object.assign({}, baseOptions), (props.preventScrollOnSwipe ? { passive: false } : {})),
                ],
                [touchEnd, onEnd, baseOptions],
            ];
            tls.forEach(([e, h, o]) => el.addEventListener(e, h, o));
            // return properly scoped cleanup method for removing listeners, options not required
            cleanup = () => tls.forEach(([e, h]) => el.removeEventListener(e, h));
        }
        return cleanup;
    };
    const onRef = (el) => {
        // "inline" ref functions are called twice on render, once with null then again with DOM element
        // ignore null here
        if (el === null)
            return;
        set((state, props) => {
            // if the same DOM el as previous just return state
            if (state.el === el)
                return state;
            const addState = {};
            // if new DOM el clean up old DOM and reset cleanUpTouch
            if (state.el && state.el !== el && state.cleanUpTouch) {
                state.cleanUpTouch();
                addState.cleanUpTouch = void 0;
            }
            // only attach if we want to track touch
            if (props.trackTouch && el) {
                addState.cleanUpTouch = attachTouch(el, props);
            }
            // store event attached DOM el for comparison, clean up, and re-attachment
            return Object.assign(Object.assign(Object.assign({}, state), { el }), addState);
        });
    };
    // set ref callback to attach touch event listeners
    const output = {
        ref: onRef,
    };
    // if track mouse attach mouse down listener
    if (handlerProps.trackMouse) {
        output.onMouseDown = onStart;
    }
    return [output, attachTouch];
}
function updateTransientState(state, props, previousProps, attachTouch) {
    // if trackTouch is off or there is no el, then remove handlers if necessary and exit
    if (!props.trackTouch || !state.el) {
        if (state.cleanUpTouch) {
            state.cleanUpTouch();
        }
        return Object.assign(Object.assign({}, state), { cleanUpTouch: undefined });
    }
    // trackTouch is on, so if there are no handlers attached, attach them and exit
    if (!state.cleanUpTouch) {
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    // trackTouch is on and handlers are already attached, so if preventScrollOnSwipe changes value,
    // remove and reattach handlers (this is required to update the passive option when attaching
    // the handlers)
    if (props.preventScrollOnSwipe !== previousProps.preventScrollOnSwipe ||
        props.touchEventOptions.passive !== previousProps.touchEventOptions.passive) {
        state.cleanUpTouch();
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    return state;
}
function useSwipeable(options) {
    const { trackMouse } = options;
    const transientState = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, initialState));
    const transientProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, defaultProps));
    // track previous rendered props
    const previousProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, transientProps.current));
    previousProps.current = Object.assign({}, transientProps.current);
    // update current render props & defaults
    transientProps.current = Object.assign(Object.assign({}, defaultProps), options);
    // Force defaults for config properties
    let defaultKey;
    for (defaultKey in defaultProps) {
        if (transientProps.current[defaultKey] === void 0) {
            transientProps.current[defaultKey] = defaultProps[defaultKey];
        }
    }
    const [handlers, attachTouch] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => getHandlers((stateSetter) => (transientState.current = stateSetter(transientState.current, transientProps.current)), { trackMouse }), [trackMouse]);
    transientState.current = updateTransientState(transientState.current, transientProps.current, previousProps.current, attachTouch);
    return handlers;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 82858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ loadAppointmentReasons; }
/* harmony export */ });
/* unused harmony export memoizedLoadApptReasonsExportedForTesting */
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37453);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(memoizee__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_MsMap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56776);
/* harmony import */ var _constants_practiceIds__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34557);
/* harmony import */ var _utils_fetch_fetches__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54428);




function loadAppointmentReasons() {
    let practiceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants_practiceIds__WEBPACK_IMPORTED_MODULE_2__/* .PracticeId.CARBON */ .I.CARBON, video = arguments.length > 1 ? arguments[1] : void 0, instant = arguments.length > 2 ? arguments[2] : void 0;
    return memoizedLoadApptReasonsExportedForTesting(practiceId, video, instant).catch(()=>[]);
}
// Exported only for testing. Prod code should call loadAppointmentReasons().
const memoizedLoadApptReasonsExportedForTesting = memoizee__WEBPACK_IMPORTED_MODULE_0___default()(async function() {
    let practiceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants_practiceIds__WEBPACK_IMPORTED_MODULE_2__/* .PracticeId.CARBON */ .I.CARBON, video = arguments.length > 1 ? arguments[1] : void 0, instant = arguments.length > 2 ? arguments[2] : void 0;
    const response = await (0,_utils_fetch_fetches__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()("/hib/practices/".concat(practiceId, "/apptReasons/v2?").concat(video ? "supportsVideoVisit=true" : "").concat(instant ? "supportsInstantVisit=true" : ""));
    return await response.json();
}, {
    maxAge: _constants_MsMap__WEBPACK_IMPORTED_MODULE_1__/* .MsMap.ONE_MINUTE */ .I.ONE_MINUTE * 20,
    promise: true
});


/***/ }),

/***/ 1399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _components_NextImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32466);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40367);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93932);
/* harmony import */ var _common_Carbon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29946);
/* harmony import */ var _Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16123);
/* harmony import */ var _Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _V5Comp__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63575);


/* eslint-disable react-hooks/rules-of-hooks */ 







const insuranceList = [
    "/anthem",
    "/blueshield",
    "/cigna",
    "/aarp",
    "/unitedhealthcare",
    "/healthnet"
];
const Insurances = ()=>{
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const { isMobile  } = (0,src_store__WEBPACK_IMPORTED_MODULE_5__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // Strings
    const tag = i18n.t("Simplified Billing");
    const header = i18n.t("We accept all major insurance plans.");
    const subheader = i18n.t("Just scan your insurance card and then you're all set.");
    const button = i18n.t("Get Started Now");
    const insurances = insuranceList.map((insurance)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["insurance-container"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NextImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().img),
                width: 150,
                height: 150,
                src: insurance,
                alt: insurance.replace("/", "")
            })
        }, insurance));
    insurances.unshift(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["insurance-container"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NextImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().img),
            width: 150,
            height: 150,
            src: insuranceList[5],
            alt: insuranceList[5].replace("/", "")
        })
    }, "insurance-padding1"));
    insurances.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["insurance-container"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NextImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().img),
            width: 150,
            height: 150,
            src: insuranceList[0],
            alt: insuranceList[0].replace("/", "")
        })
    }, "insurance-padding2"));
    const downloadUrl = isMobile ? _common_constants__WEBPACK_IMPORTED_MODULE_6__/* .downloadUrlDeeplink */ .Vx : "/download";
    const clickHandler = ()=>isMobile && (0,_common_Carbon__WEBPACK_IMPORTED_MODULE_7__/* .trackToPatient */ .Zr)({
            ga: {
                category: "Download app",
                action: "Link to app store",
                label: router.pathname
            }
        });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "".concat((_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().outer), " contrast-tbt"),
        "aria-label": i18n.t("Insurance Information"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().circle),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().inner),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().tag),
                            children: tag
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "".concat((_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header), " fw4"),
                            children: header
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            className: "".concat((_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().subheader), " fw4"),
                            children: subheader
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_V5Comp__WEBPACK_IMPORTED_MODULE_8__/* .Btn */ .un, {
                            href: downloadUrl,
                            className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().button),
                            onClick: clickHandler,
                            children: button
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().insurances),
                children: insurances
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().insurances2),
                "aria-hidden": true,
                children: insurances
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default().phone),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NextImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    width: 498,
                    height: 948,
                    src: "/insurance-scan-phone",
                    alt: i18n.t("Scan your insurance card with your phone")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Insurances_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["insurance-card"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NextImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    width: 322,
                    height: 154,
                    src: "/insurance-card",
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Insurances);


/***/ }),

/***/ 84661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const SkipSection = (param)=>{
    let { children , hrefs , style  } = param;
    const handleSpaceAndEnter = ()=>{
        for(let i = 0; i < hrefs.length; i += 1){
            const href = hrefs[i];
            const el = document.getElementById(href); // scroll to first element in hrefs found in DOM
            if (el) {
                window.location.href = "#".concat(href);
                el.focus();
                break;
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "pos-a-f bg-white gray800 ph4 pv3 br5 showOnFocus focus-bsDarkBlue3 brdn",
        style: style,
        onClick: handleSpaceAndEnter,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkipSection);


/***/ }),

/***/ 97455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45602);
/* harmony import */ var _components_SkipSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84661);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var react_swipeable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96808);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40367);
/* harmony import */ var _hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33437);
/* harmony import */ var _useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57974);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93932);
/* harmony import */ var _common_Carbon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29946);











const TestimonialSlider = (param)=>{
    let { defaultTestimons , defaultHead , autoRotate , firstBgColor , firstTextColor , smallFont =false , ariaLabel  } = param;
    const [k, setK] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { isMobile  } = (0,src_store__WEBPACK_IMPORTED_MODULE_4__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    (0,_common_Carbon__WEBPACK_IMPORTED_MODULE_8__/* .useInterval */ .Yz)(()=>{
        if ((autoRotate || isMobile) && !_common_constants__WEBPACK_IMPORTED_MODULE_7__/* .isCI */ .yg) {
            setK((k + 1) % testimons.length);
        }
    }, 8000, false);
    const head = defaultHead || i18n.t("What our patients say");
    const testimons = defaultTestimons || [
        {
            body: i18n.t("I highly recommend them to anyone needing medical attention. Reservations are easy to set up via their app and recommended to avoid wait time. Yelp only allows for 5 stars. I would give them a 10."),
            who: {
                name: "Gary",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: firstBgColor || _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint,
            color: firstTextColor || "#fff"
        },
        {
            body: i18n.t("Oh my God, finally an urgent care in our neighborhood that doesn't actually feel like an urgent care!  The space is super clean, modern, open and airy. The staff was excellent and were super friendly."),
            who: {
                name: "Gina",
                who: i18n.t("Carbon Health Los Angeles Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple,
            color: "#fff"
        },
        {
            body: i18n.t("If I could give this place 10 stars, I would. I received exceptional service from the moment I walked in, to the time I left. This place has been the best urgent care location I've ever been to."),
            who: {
                name: "Steph",
                who: i18n.t("Carbon Health San Jose Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        },
        {
            body: i18n.t("Literally amazing. They have the nicest doctors and staff, and you can get an appointment so easily and so fast! "),
            who: {
                name: "Liana",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkBlue
        },
        {
            body: i18n.t("Appreciated being seen immediately, the friendly and helpful staff, and my comprehensive care including x-rays, prescriptions called into my pharmacy and scheduling a follow-up appointment."),
            who: {
                name: "Laurie",
                who: i18n.t("Carbon Health Oakland Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint
        },
        {
            body: i18n.t("What I love is through their app (make sure you download the app - worth it) they check up on you to make sure you are ok. You are able to share any new developments."),
            who: {
                name: "Joeletta",
                who: i18n.t("Carbon Health Mountain View Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple
        },
        {
            body: i18n.t("Great urgent care! Easy to make an appointment, got seen right away, the place was clean and tidy, and the staff was extremely friendly and helpful."),
            who: {
                name: "Tessa",
                who: i18n.t("Carbon Health Berkeley Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        }
    ];
    const activeItem = testimons[k];
    const swipeHandlers = (0,react_swipeable__WEBPACK_IMPORTED_MODULE_10__/* .useSwipeable */ .QS)({
        onSwipedRight: ()=>isMobile && changeSlide(-1),
        onSwipedLeft: ()=>isMobile && changeSlide(1)
    });
    const changeSlide = (val)=>{
        const nextVal = k + val > testimons.length - 1 ? 0 : k + val < 0 ? testimons.length - 1 : k + val;
        setK(nextVal);
    };
    const isXs = (0,_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("xs");
    const headingId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    const carouselId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "lg:py-36 md:py-16 pt-16 pb-10 relative text-white contrast-tbt max-w-screen transition-colors duration-500",
        style: {
            backgroundColor: testimons[k].bg
        },
        "aria-labelledby": headingId,
        "aria-roledescription": "carousel",
        ...ariaLabel && {
            "aria-label": ariaLabel
        },
        ...swipeHandlers,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative m-auto px-4 md:px-24",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SkipSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    hrefs: [
                        "explore-locations",
                        "footer"
                    ],
                    style: {
                        left: "2rem",
                        top: "-4rem"
                    },
                    children: i18n.t("Skip Carousel")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        !activeItem.hideHeadTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "font-ir fs13 op1 ls2 mb8 mt0 ttu",
                            id: headingId,
                            children: activeItem.head || head
                        }),
                        activeItem.headImg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb8 minh20",
                            children: activeItem.headImg
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative overflow-hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "transition-transform duration-500 grid grid-flow-col",
                                style: {
                                    gridAutoColumns: "100%",
                                    transform: "translateX(".concat(-100 * k, "%)")
                                },
                                id: carouselId,
                                "aria-live": autoRotate || isMobile ? "off" : "polite",
                                children: testimons.map((t, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
                                        className: "t-op200 pos-r df fdc op0 brdn pl0 m0 ".concat(i === k ? "op1" : ""),
                                        role: "group",
                                        "aria-label": i18n.t(" {{number}} of {{total}}", {
                                            number: i + 1,
                                            total: testimons.length
                                        }),
                                        "aria-hidden": i !== k,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-cm mb8 ".concat(smallFont ? "fs28 fs18-md" : "fs40 fs24-md", " lh12 lh14-md maxw64 pb24 pb16-md fx"),
                                                children: t.body
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md mb2",
                                                children: t.who.name
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md lh14 maxw12-md",
                                                children: t.who.who
                                            }),
                                            t.source && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: t.source,
                                                rel: "noopener noreferrer",
                                                target: "_blank",
                                                className: "white fs14 font-ir us pos-a",
                                                style: {
                                                    bottom: 0
                                                },
                                                children: i18n.t("Source")
                                            })
                                        ]
                                    }, i))
                            })
                        })
                    ]
                }),
                testimons.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "df aic pos-a pos-r-xs mt4-xs",
                    style: isXs ? {} : {
                        right: "2rem",
                        bottom: isMobile ? ".25rem" : "-1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "font-mb fs12 mr6 ttu",
                            children: i18n.t(" {{number}} of {{total}}", {
                                number: k + 1,
                                total: testimons.length
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(-1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-left mr4 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Previous")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-right2 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Next")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TestimonialSlider);


/***/ }),

/***/ 6999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45602);
/* harmony import */ var _components_NextImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5621);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26420);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32466);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40367);
/* harmony import */ var _constants_specialtyIds__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93209);
/* harmony import */ var _utils_getRedirectUrl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34488);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93932);
/* harmony import */ var _common_Carbon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29946);
/* harmony import */ var _V5Comp__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63575);
/* harmony import */ var _Hero_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(38153);
/* harmony import */ var _Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12__);













const Hero = (param)=>{
    let { pathname , currentSpecialtyId  } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const { isMobile  } = (0,src_store__WEBPACK_IMPORTED_MODULE_5__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const schedulingUrl = (0,_utils_getRedirectUrl__WEBPACK_IMPORTED_MODULE_7__/* .getSchedulingRedirectUrl */ ._W)({
        virtual: true,
        specialtyId: currentSpecialtyId
    });
    const clickHandler = ()=>{
        (0,_common_Carbon__WEBPACK_IMPORTED_MODULE_9__/* .trackToPatient */ .Zr)({
            ga: {
                label: "Virtual Care"
            }
        });
    };
    const Button = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_V5Comp__WEBPACK_IMPORTED_MODULE_10__/* .Btn */ .un, {
        bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerMint,
        href: schedulingUrl,
        onClick: clickHandler,
        children: i18n.t("Book appointment")
    });
    const renderInner = ()=>{
        if (currentSpecialtyId === _constants_specialtyIds__WEBPACK_IMPORTED_MODULE_6__/* .SpecialtyId.VIRTUAL_MENTAL_HEALTH */ .mg.VIRTUAL_MENTAL_HEALTH) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().innerInner),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().r1),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().r1_c2),
                            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ "a9073fd0-4fca-4d26-8a7a-14b5d0ee55d9": { color: string; darker: string; darker2: string; hero: string; price: string; }; "31cf5e95-0952-4cbd-9a53-d4f74f729407": { color: string; darker: string; darker2: string; hero: string; price: string; }; }'.
                            style: {
                                color: _common_constants__WEBPACK_IMPORTED_MODULE_8__/* .vcData */ ._U[currentSpecialtyId].darker2,
                                textShadow: "none"
                            },
                            children: i18n.t("Introducing virtual Mental Health")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().r2),
                        style: {
                            color: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.gray800,
                            textShadow: "none"
                        },
                        children: i18n.t("Virtual mental health sessions. Wherever you are.")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().r4),
                        children: Button
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().innerInner),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().r1),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().r1_c2),
                        children: i18n.t("Introducing virtual everyday care")
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().r2),
                    children: i18n.t("Same excellent care. Wherever you are.")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().r3),
                    children: i18n.t("Get treated for a range of symptoms & conditions right from your smartphone.")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().r4),
                    children: Button
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mt18 ".concat((_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().outerWrap)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().wrap),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().inner),
                        children: renderInner()
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().inner), " ").concat((_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().lmWrap)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "#servicesWrap",
                            className: "".concat((_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().lm), " ").concat(currentSpecialtyId === _constants_specialtyIds__WEBPACK_IMPORTED_MODULE_6__/* .SpecialtyId.VIRTUAL_MENTAL_HEALTH */ .mg.VIRTUAL_MENTAL_HEALTH ? "darkerPurple-f" : ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "cIcon-mouse ".concat((_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().lm_c1)),
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().lm_c2),
                                    children: i18n.t("Learn more")
                                })
                            ]
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            height: 300
                        },
                        className: "pos-r",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NextImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            objectFit: "cover",
                            objectPosition: "0 100%",
                            src: "/vcHeroMobile",
                            layout: "fill",
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().tabs),
                children: [
                    {
                        title: "Everyday Virtual Care",
                        icon: "elb-pain",
                        color: _common_constants__WEBPACK_IMPORTED_MODULE_8__/* .vcData */ ._U[_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_6__/* .SpecialtyId.VIRTUAL_URGENT_CARE */ .mg.VIRTUAL_URGENT_CARE].darker,
                        bgColor: _common_constants__WEBPACK_IMPORTED_MODULE_8__/* .vcData */ ._U[_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_6__/* .SpecialtyId.VIRTUAL_URGENT_CARE */ .mg.VIRTUAL_URGENT_CARE].color,
                        href: {
                            pathname: _common_constants__WEBPACK_IMPORTED_MODULE_8__/* .v5Pages.virtualCare */ .Td.virtualCare
                        }
                    },
                    {
                        title: "Virtual Mental Health",
                        icon: "establish-non-physical",
                        color: _common_constants__WEBPACK_IMPORTED_MODULE_8__/* .vcData */ ._U[_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_6__/* .SpecialtyId.VIRTUAL_MENTAL_HEALTH */ .mg.VIRTUAL_MENTAL_HEALTH].darker,
                        bgColor: _common_constants__WEBPACK_IMPORTED_MODULE_8__/* .vcData */ ._U[_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_6__/* .SpecialtyId.VIRTUAL_MENTAL_HEALTH */ .mg.VIRTUAL_MENTAL_HEALTH].color,
                        href: {
                            pathname: _common_constants__WEBPACK_IMPORTED_MODULE_8__/* .v5Pages.virtualCareMental */ .Td.virtualCareMental
                        }
                    }
                ].map((t)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: t.href,
                        className: "".concat((_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().tab), " ").concat(t.href.pathname === pathname ? (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().active) : ""),
                        style: {
                            "--color": t.color,
                            "--bgColor": t.bgColor
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "".concat((_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().tab_icon), " cIcon-").concat(t.icon),
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_12___default().tab_title),
                                    children: t.title
                                })
                            ]
                        })
                    }, t.icon))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Hero);


/***/ }),

/***/ 41336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var _constants_specialtyIds__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93209);
/* harmony import */ var _utils_getRedirectUrl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34488);
/* harmony import */ var _common_Carbon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29946);
/* harmony import */ var _Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77031);
/* harmony import */ var _Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const Reasons = (param)=>{
    let { reasons , currentSpecialtyId  } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const [key, setKey] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [focus, setFocus] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    let filteredReasons = reasons// @ts-expect-error TS7006: Parameter 'r' implicitly has an 'any' type.
    .filter((r)=>r.specialtyIds.includes(currentSpecialtyId))// @ts-expect-error TS7006: Parameter 'r' implicitly has an 'any' type.
    .filter((r)=>key ? r.name.toUpperCase().includes(key) : true);
    // get popular only for virtual urgent care cos there is a lot
    if (currentSpecialtyId === _constants_specialtyIds__WEBPACK_IMPORTED_MODULE_3__/* .SpecialtyId.VIRTUAL_URGENT_CARE */ .mg.VIRTUAL_URGENT_CARE) {
        // @ts-expect-error TS7006: Parameter 'r' implicitly has an 'any' type.
        filteredReasons = filteredReasons.filter((r)=>// @ts-expect-error TS7006: Parameter 'reasonSpecialty' implicitly has an 'any' type.
            r.practiceApptReasonSpecialties.some((reasonSpecialty)=>reasonSpecialty.sortIndex));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        "aria-label": i18n.t("Common Reasons"),
        className: "".concat((_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrap), " contrast-tbt"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().c2), " contrast-tbr"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().c2C1),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().c2R1),
                            children: i18n.t("How can we help you today?")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat((_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().c2R2), " ").concat(key || focus ? (_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().on) : ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    className: (_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().c2R2C2),
                                    placeholder: i18n.t("Start typing a symptom..."),
                                    "aria-label": i18n.t("Filter symptoms"),
                                    type: "text",
                                    // value={key}
                                    onChange: (e)=>setKey(e.target.value.toUpperCase()),
                                    onFocus: ()=>setFocus(true),
                                    onBlur: ()=>setFocus(false)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "cIcon-search2 ".concat((_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().c2R2C1)),
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "visually-hidden",
                                    "aria-live": "polite",
                                    children: i18n.t("{{count}} matches found", {
                                        count: filteredReasons.length
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().c1),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().c1R1),
                    children: [
                        !filteredReasons.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().crReason),
                            style: {
                                display: "block"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "db darkerBlue-f",
                                    children: i18n.t("No result found")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: (0,_utils_getRedirectUrl__WEBPACK_IMPORTED_MODULE_4__/* .getSchedulingRedirectUrl */ ._W)({
                                        virtual: true,
                                        specialtyId: currentSpecialtyId
                                    }),
                                    className: (_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().crReason),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    onClick: ()=>(0,_common_Carbon__WEBPACK_IMPORTED_MODULE_5__/* .trackToPatient */ .Zr)(),
                                    children: [
                                        i18n.t("See all symptoms"),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "".concat((_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().rArr), " cIcon-bigRightArrow"),
                                            "aria-hidden": true
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            children: filteredReasons.map((r)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: (0,_utils_getRedirectUrl__WEBPACK_IMPORTED_MODULE_4__/* .getSchedulingRedirectUrl */ ._W)({
                                            apptReasonId: r.id,
                                            virtual: true,
                                            specialtyId: currentSpecialtyId
                                        }),
                                        className: "".concat((_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().crReason), " fbce"),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>(0,_common_Carbon__WEBPACK_IMPORTED_MODULE_5__/* .trackToPatient */ .Zr)(),
                                        children: [
                                            i18n.t(r.name),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "".concat((_Reasons_module_scss__WEBPACK_IMPORTED_MODULE_6___default().book), " contrast-tb"),
                                                children: i18n.t("Book Appointment")
                                            })
                                        ]
                                    })
                                }, r.id))
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Reasons);


/***/ }),

/***/ 728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _services_monolith_appointmentReasons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82858);
/* harmony import */ var src_constants_practiceIds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34557);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40367);



/**
 * This file is temporary because it should be removed once virtual care pages are merged into one page file.
 */ /* harmony default export */ __webpack_exports__["Z"] = (async (param)=>{
    let { store  } = param;
    const reasons = await (!store.getState().config.reasons ? (0,_services_monolith_appointmentReasons__WEBPACK_IMPORTED_MODULE_0__/* .loadAppointmentReasons */ .J)(src_constants_practiceIds__WEBPACK_IMPORTED_MODULE_1__/* .PracticeId.CARBON */ .I.CARBON) : Promise.resolve(false));
    const payload = ({
        pageLoaded: true,
        reasons: reasons && reasons.mapPick([
            "id",
            "slug",
            "name",
            "iconName",
            "description",
            "specialtyIds",
            "newPatientDuration",
            "supportsVideoVisit",
            "supportsInstantVisit",
            "practiceApptReasonSpecialties"
        ])
    }).pickBy();
    // @ts-expect-error TS2345: Argument of type 'Partial<{ pageLoaded: boolean; reasons: false | Pick<PracticeApptReason, keyof PracticeApptReason>[]; }>' is not assignable to parameter of type 'Partial<ConfigState>'.
    store.dispatch(src_store__WEBPACK_IMPORTED_MODULE_2__/* .actions.setConfig */ .Nw.setConfig(payload));
    return {};
});


/***/ }),

/***/ 16123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outer":"Insurances_outer__QkdcW","circle":"Insurances_circle__YaJPo","inner":"Insurances_inner__3mvvv","tag":"Insurances_tag__hBGKf","header":"Insurances_header__Y12Ql","subheader":"Insurances_subheader__KvQzv","button":"Insurances_button__dwX6O","phone":"Insurances_phone__9C7I6","insurance-card":"Insurances_insurance-card___gHGb","insurances":"Insurances_insurances__CpdsS","insurances2":"Insurances_insurances2__gqDkV","insurance-container":"Insurances_insurance-container__w6KlZ","img":"Insurances_img__PSyMp"};

/***/ }),

/***/ 38153:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outerWrap":"Hero_outerWrap__MjyMy","wrap":"Hero_wrap__p7MbH","inner":"Hero_inner__dTM8H","innerInner":"Hero_innerInner__QYaq7","r1":"Hero_r1___pmxF","r1_c1":"Hero_r1_c1__fTWvh","r1_c2":"Hero_r1_c2__SzpJp","r2":"Hero_r2__P8_p9","r3":"Hero_r3__Sawiu","r4":"Hero_r4__dI45Q","lmWrap":"Hero_lmWrap__XSHJx","lm":"Hero_lm__AHAKX","lm_c1":"Hero_lm_c1__hMgHa","lm_c2":"Hero_lm_c2___mY9E","tabs":"Hero_tabs__kP_hr","tab":"Hero_tab__FYQrW","active":"Hero_active__qYMIR","tab_icon":"Hero_tab_icon__41yGc","tab_title":"Hero_tab_title__rfD6F"};

/***/ }),

/***/ 77031:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Reasons_wrap__zROei","c1":"Reasons_c1__gE6_X","c2":"Reasons_c2__e_MtJ","c1R1":"Reasons_c1R1__wVeQk","rArr":"Reasons_rArr__gDniQ","crReason":"Reasons_crReason__ZaE2S","book":"Reasons_book__UPy6M","c2C1":"Reasons_c2C1__8Dw3A","c2R2":"Reasons_c2R2__KON7_","on":"Reasons_on__uo8ue","c2R2C1":"Reasons_c2R2C1__uDgNo","c2R2C2":"Reasons_c2R2C2__gHLA_"};

/***/ })

}]);